import React, { useState, useEffect } from "react";
import { Tab, Nav, Button, Table, Form, Row, Col } from "react-bootstrap";
import CustomSwitch from "utils/CustomSwitch";
import PpcSupportingRoles from "./PpcSupportingRoles";
import CustomFormCheck from "utils/CustomFormCheck";
import jsDig from "utils/jsDig";
import { v4 as uuidv4 } from "uuid";
import { useRef } from "react";
import { cloneDeep } from "lodash";

export default function Services(props) {
  const [billingConfig, setBillingConfig] = useState(props.billing_config);
  return (
    <div style={{ display: props.isEnabled ? undefined : "none" }}>
      <p className="agreement light-primary">Configure PPC subservices</p>
      {["search", "social", "display", "video"].map((section, index) => {
        const sectionName = section.charAt(0).toUpperCase() + section.slice(1);
        const [uniqueFee, setUniqueFee] = useState(props.billing_config[`${section}_fee_structure_enabled`]);
        let feeDetail =
          Object.keys(billingConfig[`${section.toLowerCase()}_fee_structure`]).length == 0
            ? [
                {
                  flat_fee: "0",
                  over_ad_spend: "0",
                  percentage_fee: "0",
                  flat_fee_enabled: "false",
                  percentage_fee_enabled: "false",
                  percentage_fee_total_over: "total",
                },
              ]
            : billingConfig[`${section.toLowerCase()}_fee_structure`];
        const handleDeleteFee = (i) => {
          let remain = feeDetail.filter((fee, index) => {
            return i != index;
          });
          let newFields = billingConfig;
          newFields[`${section}_fee_structure`] = remain;
          setBillingConfig({ ...newFields });
        };
        const [serviceEnabled, setServiceEnabled] = useState(jsDig([`${section}_section`, "enabled"], props) ? true : false);
        return (
          <div key={index} className={`${section}-subservice-agreement py-4`}>
            <Row className="d-flex justify-content-between">
              <Col className="d-flex flex-column agreement-col">
                <div className="service">
                  <div className="service-swtich ">
                    <CustomSwitch
                      label={
                        <h2 className="ppc-color pb-0 pl-3 mb-0" style={{ fontSize: "22px", marginTop: "-5px" }}>
                          {sectionName}
                        </h2>
                      }
                      variant="ppc"
                      text={sectionName}
                      id={`${section}-subservice`}
                      customClass="d-inline-block"
                      name={`${section}_enabled`}
                      isEnabled={serviceEnabled}
                      setIsEnabled={setServiceEnabled}
                      disabled={!props.isEnabled}
                    />
                  </div>
                  <div className="fee-structure-radio">
                    <Form.Check
                      style={{ color: "#7B7DA4" }}
                      className="visby-bold ppc-serve"
                      name={`[billing_config][${section}][fee_structure_enabled]`}
                      custom
                      label="Add to shared fee structure"
                      type="radio"
                      defaultChecked={!uniqueFee ? true : false}
                      value="0"
                      id={`${section}-shared-fee-structure`}
                      onChange={() => {
                        setUniqueFee(false);
                      }}
                      disabled={!props.isEnabled}
                    />
                    <Form.Check
                      name={`[billing_config][${section}][fee_structure_enabled]`}
                      className="visby-bold ppc-serve"
                      custom
                      label="Use unique fee structure"
                      type="radio"
                      defaultChecked={uniqueFee ? true : false}
                      value="1"
                      id={`${section}-unique-fee-structure`}
                      onChange={() => {
                        setUniqueFee(true);
                      }}
                      disabled={!props.isEnabled}
                    />
                  </div>
                </div>
                <div className="table-responsive mt-3">
                  <Table className="pb-3">
                    <tbody>
                      {feeDetail.map((detail, i) => {
                        const flatFeeEnabled = detail["flat_fee_enabled"] == "1";
                        const percentageEnabled = detail["percentage_fee_enabled"] == "1";
                        const greyout = uniqueFee && serviceEnabled ? null : { opacity: "0.6" };

                        return (
                          <tr key={i} style={greyout}>
                            <td className="pr-0">
                              <div className="mr-0 input-box4">
                                Over ad spend
                                <Form.Control
                                  size="sm"
                                  className="cw1"
                                  placeholder="0"
                                  name={`${section}_fee_structure[][over_ad_spend]`}
                                  value={detail.over_ad_spend ? detail.over_ad_spend : ""}
                                  disabled={!uniqueFee || !serviceEnabled}
                                  onChange={(e) => {
                                    let newOverallSpend = cloneDeep(billingConfig);
                                    // newOverallSpend[`${section}_fee_structure`][i] = [detail];
                                    newOverallSpend[`${section}_fee_structure`][i]["over_ad_spend"] = e.target.value;
                                    setBillingConfig({ ...newOverallSpend });
                                  }}
                                />
                                <span className="unit">$</span>
                                <span style={{ paddingRight: "15px" }}>charge</span>
                              </div>
                            </td>
                            <td>
                              <div className="d-flex align-items-center">
                                <div style={{ width: "16px" }} className="pr-0">
                                  <CustomFormCheck
                                    disabled={!uniqueFee || !serviceEnabled}
                                    id={` ${section} + ppccharge ` + `${i}`}
                                    name={`${section}_fee_structure[][flat_fee_enabled]`}
                                    checked={flatFeeEnabled}
                                    sendUncheckedValue={!flatFeeEnabled}
                                    onChange={() => {
                                      let newFlatFeeEnabled = cloneDeep(billingConfig);
                                      if (uniqueFee) {
                                        // newFlatFeeEnabled[`${section}_fee_structure`] = [detail];
                                        newFlatFeeEnabled[`${section}_fee_structure`][i]["flat_fee_enabled"] = !flatFeeEnabled;
                                        setBillingConfig({
                                          ...newFlatFeeEnabled,
                                        });
                                      }
                                    }}
                                  />
                                </div>
                                <div className="input-box2">
                                  <Form.Control
                                    size="sm"
                                    className="cw2"
                                    placeholder="0"
                                    style={{ opacity: flatFeeEnabled ? null : "0.6" }}
                                    name={`${section}_fee_structure[][flat_fee]`}
                                    disabled={!uniqueFee || !serviceEnabled || !flatFeeEnabled}
                                    value={detail.flat_fee ? detail.flat_fee : ""}
                                    onChange={(e) => {
                                      let newOverallSpend = cloneDeep(billingConfig);
                                      // newOverallSpend[`${section}_fee_structure`] = [detail];
                                      newOverallSpend[`${section}_fee_structure`][i]["flat_fee"] = e.target.value;
                                      setBillingConfig({ ...newOverallSpend });
                                    }}
                                  />
                                  <span className="unit">$</span>
                                </div>
                              </div>
                            </td>
                            <td className="p-0">
                              <div className="d-flex pl-0  align-items-center">
                                <div style={{ width: "16px" }}>
                                  <CustomFormCheck
                                    disabled={!uniqueFee || !serviceEnabled}
                                    name={`${section}_fee_structure[][percentage_fee_enabled]`}
                                    id={`${section} + ppcrev ` + `${i}`}
                                    checked={percentageEnabled}
                                    onChange={() => {
                                      let newPercentageFeeEnabled = billingConfig;
                                      if (uniqueFee) {
                                        // newPercentageFeeEnabled[`${section}_fee_structure`] = [detail];

                                        newPercentageFeeEnabled[`${section}_fee_structure`][i]["percentage_fee_enabled"] = !percentageEnabled;
                                        setBillingConfig({
                                          ...newPercentageFeeEnabled,
                                        });
                                      }
                                    }}
                                    sendUncheckedValue={!percentageEnabled}
                                  />
                                </div>
                                <Form.Control
                                  as="select"
                                  className="mr-0"
                                  size="sm"
                                  style={{ opacity: percentageEnabled ? null : "0.6" }}
                                  name={`${section}_fee_structure[][percentage_fee_total_over]`}
                                  placeholder="0"
                                  disabled={!uniqueFee || !serviceEnabled || !percentageEnabled}
                                  value={detail.percentage_fee_total_over ? detail.percentage_fee_total_over : ""}
                                  onChange={(e) => {
                                    let newOverallSpend = cloneDeep(billingConfig);
                                    // newOverallSpend[`${section}_fee_structure`] = [detail];

                                    newOverallSpend[`${section}_fee_structure`][i]["percentage_fee_total_over"] = e.target.value;
                                    setBillingConfig({ ...newOverallSpend });
                                  }}>
                                  <option value="total">total</option>
                                  <option value="over">partial</option>
                                </Form.Control>
                                <div className="input-box3">
                                  <Form.Control
                                    size="sm"
                                    style={{ width: "100px", color: "#2c345b ", opacity: percentageEnabled ? null : "0.6" }}
                                    disabled={!uniqueFee || !serviceEnabled || !percentageEnabled}
                                    name={`${section}_fee_structure[][percentage_fee]`}
                                    value={detail.percentage_fee ? detail.percentage_fee : ""}
                                    placeholder="0"
                                    onChange={(e) => {
                                      let newOverallSpend = cloneDeep(billingConfig);
                                      // newOverallSpend[`${section}_fee_structure`] = [detail];

                                      newOverallSpend[`${section}_fee_structure`][i]["percentage_fee"] = e.target.value;
                                      setBillingConfig({ ...newOverallSpend });
                                    }}
                                  />
                                  <span className="unit">%</span>
                                </div>
                                {(i >= 0 && feeDetail.length > 1) && (
                                  <i
                                    className={!uniqueFee || !serviceEnabled ? "fas fa-minus-circle fa-disabled" : "fas fa-minus-circle"}
                                    onClick={(e) => handleDeleteFee(i)}></i>
                                )}
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>
                <div>
                  <Button
                    style={{ paddingLeft: "14px" }}
                    className="my-3 btn-sm center-mobile-button"
                    variant="success"
                    disabled={!serviceEnabled || !uniqueFee}
                    onClick={() => {
                      let newArray = [
                        ...feeDetail,
                        {
                          flat_fee: "0",
                          over_ad_spend: "0",
                          percentage_fee: "0",
                          flat_fee_enabled: "false",
                          percentage_fee_enabled: "false",
                          percentage_fee_total_over: "total",
                        },
                      ];
                      let arrayForChange = billingConfig;
                      arrayForChange[`${section}_fee_structure`] = newArray;
                      setBillingConfig({ ...arrayForChange });
                    }}>
                    + Add Condition
                  </Button>
                </div>
              </Col>
              <Col className="d-flex pl-3 pl-lg-0 flex-column ">
                <PpcSupportingRoles {...props} service={section} isEnabled={props.isEnabled} />
              </Col>
            </Row>
          </div>
        );
      })}
    </div>
  );
}
